import type React from "react";
import { useNetlifySDK } from "../use_netlify_sdk.js";
import { ExtensionSettingsHeader } from "./ExtensionSettingsHeader.jsx";
import { ProviderAuthCard } from "./ProviderAuthCard.jsx";
import { SettingsCard } from "./SettingsCard.jsx";

export type ExtensionSettingsProps = {
  children: React.ReactNode;
  subheader?:
    | React.ReactNode
    | ((options: { name: string }) => React.JSX.Element)
    | undefined;
};

export const ExtensionSettings = ({
  children,
  subheader,
}: ExtensionSettingsProps) => {
  const sdk = useNetlifySDK();

  return (
    <section id={`section-${sdk.extension.slug}`}>
      <ExtensionSettingsHeader subheader={subheader} />

      <ProviderAuthCard />

      <SettingsCard>{children}</SettingsCard>
    </section>
  );
};
